import React, { FC, ReactNode } from 'react';
import cx from 'classnames';

import { Container, Layout } from 'components/ui';

import styles from './styles.module.css';

type ContentProps = {
  className?: string;
  children: ReactNode;
};

const Content: FC<ContentProps> = ({ className, children }) => {
  return (
    <Layout.Content className={cx(styles.root, className)}>
      <Container className={styles.container}>{children}</Container>
    </Layout.Content>
  );
};

export default Content;
